import { CurrentMechanic, Mechanic, Route, populateRoute } from "@repo/common"
import { queryOptions } from "@tanstack/react-query"
import { request } from "../api"

interface MechanicFilter extends Partial<Mechanic> {
  storeId: string
}

interface MechanicDetailFilter extends MechanicFilter {
  mechanicId: string
}

async function fetchMechanics(filters: MechanicFilter): Promise<Mechanic[]> {
  const { storeId } = filters

  const mechanics = await request<Mechanic[]>({
    url: populateRoute(
      Route.MECHANIC_CONTROLLER__FIND_MANY_BY_STORE_ID,
      storeId,
    ),
    method: "GET",
  })

  return mechanics
}

async function fetchMechanic(
  filters: MechanicDetailFilter,
): Promise<Mechanic | undefined> {
  const { mechanicId, storeId } = filters

  return request<Mechanic>({
    url: populateRoute(
      Route.MECHANIC_CONTROLLER__FIND_ONE_BY_ID,
      mechanicId,
      storeId,
    ),
    method: "GET",
  })
}

async function fetchCurrentMechanic(storeId: string): Promise<CurrentMechanic> {
  return request<CurrentMechanic>({
    url: populateRoute(Route.MECHANIC_CONTROLLER__FIND_CURRENT, storeId),
    method: "GET",
  })
}

export const mechanicQueries = {
  all: () => ["mechanics"],
  lists: () => [...mechanicQueries.all(), "list"],
  list: (filters: MechanicFilter) =>
    queryOptions({
      queryKey: [...mechanicQueries.lists(), filters],
      queryFn: () => fetchMechanics(filters),
      staleTime: Number.POSITIVE_INFINITY,
    }),
  details: () => [...mechanicQueries.all(), "detail"],
  detail: (filters: MechanicDetailFilter) =>
    queryOptions({
      queryKey: [...mechanicQueries.details(), filters],
      queryFn: () => fetchMechanic(filters),
      staleTime: Number.POSITIVE_INFINITY,
    }),
  current: (storeId: string) =>
    queryOptions({
      queryKey: [...mechanicQueries.all(), "current", storeId],
      queryFn: () => fetchCurrentMechanic(storeId),
      staleTime: Number.POSITIVE_INFINITY,
    }),
}
